export default {
  title: "Профиль",
  buttons: {
    logout: "Чыгуу",
  },
  labels: {
    email: "Электрондук почта",
    phone: "Телефон номери",
  },
  placeholders: {
    notSpecified: "Көрсөтүлгөн эмес",
  },
  sections: {
    usefulContacts: "Пайдалуу байланыштар",
  },
  notifications: {
    profileChanges:
      "Маалыматтарды өзгөртүү зарыл болсо, колдоо кызматына {phone} номери аркылуу, {telegram}, {whatsapp} мессенжерлеринде же {email} электрондук дареги аркылуу кайрылыңыз.",
  },
  tariff_badge: {
    lite_p: "Лайт",
    promo_p: "Промо",
    basic: "Негизги",
    pluspro_p: "Про+",
    corporate: "Корпоративдик",
  },
  tariff_hint: "Жазылуу жок, бардык функцияларга жетүү үчүн тариф тандаңыз",
  choose_tariff_button: "Тарифти тандоо",

  contactCard: {
    titles: {
      priorityService: "Приоритеттүү тейлөө",
      distributor: "Дистрибьютор",
    },
    hints: {
      upgradeTariff:
        "Акыл төлөнүүчү тарифке кошулганда, жеке менеджердин байланыштары жеткиликтүү болот",
    },
    upgradeTariff: {
      message:
        "Төлөнүүчү тариф менен жеке менеджер аркылуу маселелериңизди тезирээк чечиңиз.",
      button: "Тариф сатып алуу",
    },
    extNumber: "кош.",
  },
  managerSchedule: {
    todayWithTime: "Бүгүн {time} (МСК)",
    todayDayOff: "Бүгүн - эс алуу күнү",
    weekdays: {
      monday: "Дүйшөмбү",
      tuesday: "Шейшемби",
      wednesday: "Шаршемби",
      thursday: "Бейшемби",
      friday: "Жума",
      saturday: "Ишемби",
      sunday: "Жекшемби",
    },
  },
};
